import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgGermanFlagRounded = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.918 12.027c0-1.39-.243-2.724-.684-3.964H.684A11.805 11.805 0 0 0 0 12.026c0 1.39.242 2.724.683 3.964h22.551c.441-1.24.684-2.573.684-3.963Z",
    fill: "#E60012"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.96.135C6.752.135 2.325 3.445.683 8.063h22.55A11.957 11.957 0 0 0 11.96.135Z",
    fill: "#231815"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.235 15.99H.684a11.957 11.957 0 0 0 11.275 7.928c5.207 0 9.634-3.31 11.276-7.928Z",
    fill: "#FFE200"
  })]
}));
export default SvgGermanFlagRounded;